module.exports = {
  'Common.payouts': 'retirar',
  'Common.deposit': 'Depósito',
  'Common.all': 'todo',
  'Common.CopySuccess': 'Copiado correctamente',
  'Header.login': 'Iniciar sesión',
  'Header.registro':  'Registro',
  'BottomNav.home': 'iniciar',
  'BottomNav.share': 'instalar',
  'BottomNav.promotion': 'Promoción',
  'BottomNav.inTheTank': 'apoyo',
  'BottomNav.user-info': 'Perfil',
  'Pay.deposit-online': 'Depósito en línea',
  'Pay.deposit-money': 'Monto del depósito',
  'Pay.deposit-prompt': 'Condiciones de uso: Tras realizar el pago correctamente, el sistema añadirá el importe a su cuenta en un plazo de 1 a 5 minutos.',
  'Pay.min': 'mínimo',
  'Pay.max': 'Máximo',
  'Pay.deposit-submit': 'Recarga ahora',
  'Pay.Extra': 'extra',
  'History.1': 'tiempo',
  'History.2': 'Tasa de progreso',
  'History.3': 'Dinero',
  'Withdraw.1': 'Monto disponible para retiros',
  'Withdraw.2': 'Account',
  'Withdraw.3': 'Monto de retiro',
  'Withdraw.4': 'retirar',
  'Withdraw.5': 'Saldo disponible insuficiente',
  'Withdraw.6': 'confirmar',
  'Withdraw.7': 'indicio',
  'Withdraw.8': 'Por favor, introduzca correctamente el número de cuenta bancaria, el nombre y la dirección de correo electrónico. Para poder retirar fondos, es imprescindible que toda la información de la cuenta sea correcta.',
  'Withdraw.9': 'El retiro falló. Verifique que la información de la cuenta de retiro sea correcta o cambie la cuenta de retiro e intente retirar nuevamente.',
  'WithdrawPopups.1': 'indicio',
  'WithdrawPopups.2': 'Estimado usuario, usted es un usuario nuevo y aún no tiene habilitados los retiros. Deposite cualquier cantidad para habilitar esta función y luego retire sus fondos.',
  'WithdrawPopups.3': 'Ve a recargar',
  'WithdrawPopups.4': 'Estimado usuario VIP, su solicitud de retiro ha sido aceptada correctamente. Por favor, verifique el saldo de su cuenta bancaria.',
  'WithdrawPopups.5': 'confirmar',
  'WithdrawPopups.6': 'Estimado miembro, este es su primer retiro. Para ayudarle a familiarizarse con el proceso de retiro de la plataforma, seleccione el monto mínimo de retiro {amount}.',
  'WithdrawPopups.7': '¡Enhorabuena! Tu retiro se ha acreditado correctamente en tu cuenta bancaria. ¡Sigue jugando para ganar más dinero!',
  'WithdrawPopups.8': 'Estimado usuario, le invitamos cordialmente a participar en el plan de mejora del juego. Por favor, complete su experiencia de juego antes de realizar cualquier retiro.',
  'WithdrawPopups.9': 'Ve a Configuración',
  'WithdrawPopups.10': 'Estimado usuario:<br/>Para la seguridad de su cuenta, establezca una contraseña de retiro y vincule una cuenta bancaria única para retiros inmediatamente después de su primer retiro exitoso.<br/>Una vez vinculada, su cuenta de juego solo podrá retirar fondos de la cuenta bancaria vinculada, protegiendo así sus fondos.',
  'WithdrawPopups.11': 'Estimado usuario, el límite de retiro individual para usuarios de nivel Bronce es de {amount}. Seleccione {amount} para retirar. Al actualizar a la tarjeta Plata, desbloqueará un límite de retiro personal mayor.',
  'WithdrawPopups.12-1': 'Estimado usuario de nivel Bronce, las reglas de retiro para su nivel VIP son las siguientes:<br/>1. Puede realizar un retiro cada 60 horas.<br/>2. El límite de retiro por transacción es de {monto}. Le pedimos paciencia.',
  'WithdrawPopups.12-2': 'Los retiros solo son posibles después de [número] horas; de lo contrario, puede actualizar su estatus a Tarjeta Plata. <br/><br/>Las reglas de retiro de la Tarjeta Plata son:<br/>1. Hasta 5 retiros por día.<br/>2. El límite de cada retiro es de 300 reales.',
  'WithdrawPopups.13': 'Mejora a Tarjeta Plata',
  'WithdrawPopups.14': 'Deposita {cantidad} para subir al rango Plata',
  'WithdrawPopups.15': '¡Felicidades por alcanzar el nivel más alto de usuario Rey Inigualable! Solo necesitas recargar una vez, con un monto de {amount} o más, para desbloquear todos los beneficios de Rey Inigualable. Una vez desbloqueados, disfrutarás de los siguientes privilegios:<br/>1. Eliminación de todas las restricciones del juego<br/>2. Retiros fáciles en cualquier momento, sin límite diario de monto ni frecuencia de retiro<br/>3. Usa el canal de retiro exclusivo de Rey Inigualable; tus retiros se acreditarán al instante.',
  'WithdrawPopups.16': 'Desbloquea y paga {cantidad}',
  'WithdrawPopups.17': 'Su solicitud de retiro se está procesando. Por favor, espere a que se complete el proceso antes de proceder con el retiro. Gracias.',
  'WithdrawPopups.18': 'Cuentas asociadas',
  'WithdrawPopups.19': 'Estimado usuario:<br/>Una vez vinculada correctamente la cuenta de retiro designada, podrá retirar fondos con normalidad.<br/>Cómo vincular una cuenta de retiro designada:<br/>1. Introduzca la cuenta de retiro que desea utilizar.<br/>2. Deposite {cantidad} para activar la cuenta de retiro designada.',
  'WithdrawPopups.20': 'Deposita {cantidad} para activar la cuenta.',
  'pix.1_1': 'Paso 1',
  'pix.1_2': 'Paso 2',
  'pix.1_3': 'Paso 3',
  'pix.1_4': 'Paso 4',
  'pix.2': 'Establecer contraseña de retiro',
  'pix.3': 'Por favor, configure su contraseña de retiro.',
  'pix.4': 'Por favor, introduzca una contraseña de 6 dígitos.',
  'pix.5': 'Recuerde su contraseña de retiro después de configurarla.',
  'pix.6': 'Siguiente paso',
  'pix.7': 'Vinculado a una única cuenta de retiro',
  'pix.8': 'Nombre del titular de la cuenta',
  'pix.9': 'Introduzca el nombre del titular de la cuenta.',
  'pix.10': 'Por favor, introduzca su número de cuenta bancaria.',
  'pix.11': 'progreso',
  'pix.12': 'Tras vincular una cuenta específica para retiros, el sistema solo admitirá retiros de juegos desde la cuenta bancaria vinculada, lo que hará que los fondos de tu cuenta de juego estén más seguros.',
  'pix.13': 'Mensaje de confirmación',
  'pix.14': 'Contraseña de retiro:',
  'pix.15': 'Propietario de la cuenta:',
  'pix.16': 'Por favor, revise cuidadosamente la información de su cuenta y recuerde su contraseña de retiro para garantizar la seguridad de los fondos de su cuenta.',
  'pix.17': 'Verificar cuenta y contraseña de activación',
  'pix.18': 'Por favor, active su contraseña de retiro y verifique su cuenta de retiro única.',
  'pix.19': 'método:',
  'pix.20': '1. Deposite <span style="color: #FEC929;font-size:14rem;">{cantidad></span><br>2. Tras completar el pago, el sistema activará automáticamente la contraseña de retiro y verificará la cuenta de retiro.</span></br>',
  'pix.21': 'Una vez completado el pago, la cuenta de retiro se vinculará automáticamente y podrá retirar sus fondos con normalidad.',
  'pix.22': 'activación',
  'pix.23': 'Detalles del pedido',
  'pix.24': 'Valor del pedido:',
  'pix.25': 'Cantidad recibida:',
  'pix.26': 'Ve a pagar {cantidad}',
  'drawcash.1': 'cuentas bancarias asociadas',
  'drawcash.name1': 'Nombre del titular de la cuenta',
  'drawcash.name2': 'Introduzca el nombre del titular de la cuenta.',
  'drawcash.type': 'Tipo de clave',
  'drawcash.PIX': 'PIX',
  'drawcash.PIX1': 'Por favor, introduzca su número de cuenta bancaria.',
  'drawcash.CPF': 'cuenta bancaria',
  'drawcash.CPF1': 'Por favor, introduzca su número de cuenta bancaria.',
  'drawcash.tellNum': 'número telefónico',
  'drawcash.tellNum1': 'Por favor, introduzca su número de teléfono.',
  'drawcash.confirm': 'confirmar',
  'PayModal.deposit-log': 'Historial de recargas',
  'PayModal.deposit-verify-money': 'Seleccione el importe que desea recargar.',
  'LeftNav.popular': 'Popular',
  'LeftNav.recently': 'Reciente',
  'LeftNav.favorites': 'Favoritos',
  'More.game-more': 'Mostrando {current} juegos, totalizando {total} juegos y juegos {name}.',
  'More.more': 'Cargar más',
  'Mine.recover': 'Restablecer el equilibrio',
  'Mine.millions-month': 'Millones al mes',
  'Mine.account': 'Cuenta',
  'Mine.user-info': 'Perfil',
  'Mine.VIP': 'Nivel VIP',
  'Mine.service': 'Servicio al cliente',
  'Mine.language': 'idioma',
  'Mine.loginOut': 'Finalizar la sesión',
  'Mine.bind': 'Vincular cuenta',
  'Mine.loginSuccess': 'Salida exitosa',
  'Mine.1': 'Vincular cuenta de inicio de sesión',
  'Mine.2': 'Configurar cuenta de inicio de sesión',
  'Mine.3': 'confirmar',
  'Safety.security-center': 'Centro de seguridad',
  'Security.Withdraw': 'retirar',
  'Security.record': 'Registros de retiro',
  'Notice.bonus': 'Bonificación por sugerencia',
  'Notice.message-center': 'Centro de mensajes',
  'Notice.message': 'Noticias',
  'Notice.notice': 'Notificación',
  'Notice.scroll-panel': 'Panel enrollable',
  'Setting.data': 'Datos',
  'Setting.back': 'Devolver',
  'Setting.save': 'Ahorrar',
  'Setting.day': 'Día',
  'Setting.month': 'Mes',
  'Setting.year': 'Año',
  'Promote.success': 'Recibido con éxito',
  'Promote.failed': 'No se pudo recopilar',
  'Promote.copy': 'Copiar',
  'Promote.invite': 'invitación',
  'Promote.my': 'mi invitación',
  'Promote.Today': 'Hoy',
  'Promote.All': 'todo',
  'Promote.Number': 'Registro',
  'Promote.Rewards': 'premio',
  'Promote.myRewards': 'Mi recompensa',
  'Promote.received': 'Recibió',
  'Promote.receive': 'recibir',
  'Promote.collected': 'Disponible',
  'Promote.media': 'Comparte en tus redes sociales',
  'Promote.friends': 'Comparte el enlace con tus amigos',
  'Vip.title': 'Club VIP',
  'Vip.charge': 'Recarga acumulativa',
  'Vip.1': 'Desbloqueo de nivel',
  'Vip.2': 'Actualiza a VIP para desbloquear más privilegios.',
  'Vip.3': 'Nivel VIP por desbloquear',
  'Vip.4': 'Desbloqueado',
  'Vip.5': '¡Enhorabuena! Has desbloqueado todos los niveles.',
  'vip.0': 'Hierro negro',
  'vip.1': 'bronce',
  'vip.2': 'PLATA',
  'vip.3': 'ORO',
  'vip.4': 'DIAMANTE',
  'vip.5': 'Gran Maestro',
  'vip.6': 'Rey',
  'vip.7': 'rey sin igual',
  'Service.service': 'Servicio al cliente',
  'Services.common': 'problema común',
  'Services.How': '¿Cómo puedo retirar dinero?',
  'Services.withdrawal': 'Estimado usuario, el retiro de efectivo es un privilegio VIP. Deposite cualquier cantidad para convertirse en VIP y desbloquear los privilegios de retiro.',
  'Services.1': '¿Hay alguna comisión por las retiradas?',
  'Services.2': 'No cobramos comisiones por retiro. Nos comprometemos a brindar a los jugadores una experiencia de juego transparente y justa, que incluye la posibilidad de obtener bonos sin pagar cargos adicionales.',
  'EventItem.title': 'Completa la tarea y recibe la recompensa.',
  'EventItem.content': 'dinero',
  'EventItem.send': 'M$90',
  'EventItem.Receber': 'recibir',
  'EventItem.rewards': 'Completa la tarea y recibe la recompensa.',
  'EventItem.Already': 'Recibió',
  'EventItem.1': 'Completo',
  'EventItem.2': 'Recomendaciones de apuestas para tragamonedas de BET:',
  'EventItem.3': 'compartir',
  'eventItem2.checkin': 'registrarse',
  'eventItem2.Complete': 'Deposita cualquier cantidad para recibir un bono de 7 días.',
  'eventItem2.notGet': 'La recompensa actual no se puede reclamar.',
  'eventItem2.Successful': 'Inicio de sesión exitoso',
  'eventItem2.failed': 'Error al iniciar sesión',
  'eventItem2.1': 'Tarea para principiantes',
  'eventItem2.2': 'Recompensas diarias',
  'eventItem2.3': 'Tareas del sistema',
  'About.about': 'sobre',
  'about.1': '¡BET es un juego de tragamonedas gratis! Ofrecemos una enorme selección de tragamonedas al estilo Las Vegas, con la mayor variedad y las ofertas más competitivas del mercado. Todas las plataformas se seleccionan entre plataformas de juego en línea reconocidas internacionalmente para garantizar que todos los jugadores disfruten de un entorno de juego justo y confiable. Además, el gobierno mexicano supervisa los datos de la plataforma de juego para asegurar la imparcialidad y autenticidad de los juegos. ¡Disfruta de la emoción de las tragamonedas de la suerte!',
  'about.1.bak': '¡BET es un juego de tragamonedas gratis! Ofrecemos una enorme selección de tragamonedas al estilo Las Vegas, con la mayor variedad y las ofertas más competitivas del mercado. Todas las plataformas se seleccionan entre plataformas de juego en línea reconocidas internacionalmente para garantizar que todos los jugadores disfruten de un entorno de juego justo y confiable. Además, el gobierno mexicano supervisa los datos de la plataforma de juego para asegurar la imparcialidad y autenticidad de los juegos. ¡Disfruta de la emoción de las tragamonedas de la suerte!',
  'about.2': 'sobre nosotros',
  'about.3': 'BET Slots es un reconocido operador internacional de casinos en línea que ofrece una amplia variedad de juegos emocionantes, tragamonedas, juegos de pesca, loterías, apuestas deportivas y mucho más. BET Slots garantiza que todos los jugadores puedan jugar en un entorno justo y confiable, y se compromete a brindar la mejor experiencia de juego.',
  'notice.1': 'Felicidades',
  'notice.2': 'retirar',
  'empty.1': 'No hay juegos disponibles',
  'limitPops.1': 'pista',
  'limitPops.3': 'El sistema se encuentra actualmente en mantenimiento. Por favor, manténgase al tanto.',
  'limitPops.4': 'confirmar',
  'limitPops.5': 'Actualmente eres usuario de nivel Hierro Negro y solo puedes jugar al juego Buey de la Fortuna. El juego PG solo está disponible para usuarios de nivel Bronce.',
  'limitPops.6': 'Juega a Fortune OX',
  'limitPops.7': 'Ve a desbloquear',
  'limitPops.8': '¡Enhorabuena! Has recibido M$30 gratis del sistema. Puedes empezar a jugar ahora para ganar más dinero.',
  'limitPops.9': 'Actualmente eres usuario de nivel Hierro Negro y solo puedes jugar a Fortune OX. El juego {gameType} solo está disponible para usuarios de nivel {VIP}.',
  'limitPops.10': 'Recarga {cantidad} para subir al nivel Rey Inigualable y eliminar todas las restricciones del juego.',
  'limitPops.11': 'Ve a recargar',
  'limitPops.12': 'El juego JILI solo está disponible para usuarios de nivel Plata; puedes desbloquearlo subiendo de nivel a Plata.',
  'limitPops.13': 'Los juegos PP solo están disponibles para usuarios de nivel Oro; puedes desbloquearlos actualizando a nivel Oro.',
  'limitPops.14': 'El juego MG solo está disponible para usuarios de nivel Diamante; puedes desbloquearlo subiendo de nivel a Diamante.',
  'limitPops.15': 'El juego {gameType} solo está disponible para usuarios de nivel Gran Maestro; puedes desbloquearlo actualizando a Gran Maestro.',
  'limitPops.16': 'El juego {gameType} solo está disponible para usuarios de nivel Rey; actualiza a Rey para desbloquearlo.',
  'limitPops.20': 'El juego {gameType} solo está disponible para jugadores de nivel Rey Inigualable; puedes desbloquearlo al subir a Rey Inigualable.',
  'limitPops.17': 'Juega juegos PG',
  'limitPops.18': 'Desbloquea otros juegos',
  'limitPops.19': 'Recarga cualquier cantidad para subir al nivel Bronce y desbloquear todos los juegos PG.',
  'limitPops.21': '',
  'bottom.1': 'casino',
  'bottom.1_1': 'Eventos',
  'bottom.1_2': 'Primo',
  'bottom.1_3': 'VIP',
  'bottom.1_4': 'Invitar',
  'bottom.2': 'juego',
  'bottom.2_1': 'Slots',
  'bottom.2_2': 'Pesca',
  'bottom.3': 'Apoyo',
  'bottom.3_1': 'Soporte en línea',
  'bottom.4': 'introducir',
  'bottom.5': 'Otro',
  'tipsPop.1': 'Estimados jugadores, ¡felicidades! Tras ganar más de 3000 $, han ascendido a nuestro nivel más alto: "Rey de los Guerreros". ¡Que disfruten del juego!',
  'tipsPop.2': 'Felicidades',
  'tipsPop.3': '¡Enhorabuena! Has ganado {amount} en el juego. Por seguridad, completa el retiro antes de continuar jugando.',
  'tipsPop.4': 'Retirar',
  'tipsPop.5': 'Estimado usuario, ¡bienvenido a BET Slots Casino World! ¡Regístrese ahora para recibir un bono de M$20!',
  'tipsPop.6': 'Regístrate ahora',
  'login.1': 'Regístrate y vincula una cuenta',
  'login.9': 'Login',
  'login.2': 'Introduce tu número de teléfono móvil',
  'login.3': 'Introduzca su contraseña.',
  'login.4': 'Por favor, introduzca su contraseña de nuevo.',
  'login.5': '¿Ya tienes una cuenta? Inicia sesión.',
  'login.6': '¿Aún no tienes una cuenta? Regístrate para obtener una cuenta.',
  'login.7': 'Registro',
  'login.8': 'Login',
  'login.10': 'U',
  'login.11': 'Cambiar cuenta',
  'popTips.1': 'Estimado miembro, felicitaciones por haber retirado con éxito M$10. Por favor, revise su cuenta.',
  'gamePro.1': '¡Intenta crear milagros y cuanto más juegues, más ganarás!',
  'process.toCharge': 'depósito',
  'process.payTax': 'Pagar impuestos',
  'process.toWithDraw': 'retirar',
  'process.toGame': 'Juega juegos',
  'process.tips1': 'Deposita cualquier cantidad para obtener la función de retiro.',
  'process.tips2': 'Saldo insuficiente en la cuenta, juega y gana dinero',
  'process.tips3': 'Si su nivel de membresía es insuficiente, recargue más para mejorar su nivel de membresía y aumentar su límite de retiro.',
  'process.tips4': 'Se ha solicitado su orden de retiro. Los pedidos grandes requieren revisión manual. ¡Por favor, espere!',
  'process.tips5': 'La oferta de retiro de M$3 es exclusiva para nuevos usuarios y solo se puede aprovechar una vez por cuenta bancaria. Cambia tu cuenta bancaria para realizar retiros o continúa depositando fondos para obtener mayores privilegios de retiro.',
  'process.tipsLevel2': 'Estimado jugador, su cuenta no está en nuestra lista blanca. Deposite M$150 para desbloquearla y podrá retirar fondos de inmediato.',
  'process.tipsLevel4': 'Lo sentimos, la transacción falló debido a la alta actividad en el sistema bancario. Por favor, inténtelo de nuevo.',
  'process.tipsLevel5': 'Estimado jugador, su nivel de actividad en el juego es insuficiente. Por favor, juegue un rato antes de realizar un retiro.',
  'process.tipsLevel6': 'Estimado usuario, su solicitud de retiro de gran monto requiere revisión manual. Debido a la gran cantidad de personas en la cola, el tiempo de procesamiento será prolongado. Puede depositar M$300 para activar de inmediato el 【Canal de Retiro Súper】, evitar la cola, recibir los fondos al instante y disfrutar de un servicio de retiro ultrarrápido.',
  'process.tipsLevel7': 'El banco le ha informado de que esta retirada de gran importe se considera renta personal adicional y está sujeta a un impuesto sobre la renta personal del  {tax}% según la normativa vigente. Importe del impuesto: M${amount}',
  'process.tipsLevel8': 'Retiro fallido. Debido a la alta frecuencia de operaciones, tu cuenta de juego ha sido temporalmente congelada. Por favor, completa las tareas del juego para desbloquearla.',
  'process.tipsLevel9': 'La operación de retiro falló. Hay demasiadas personas intentando retirar fondos en este momento. Inténtelo de nuevo más tarde.',
  'process.tipsLevel10': 'Estimado usuario, dado que esta es la primera vez que actualiza a una cuenta premium, para garantizar la seguridad de sus fondos, seleccione primero un retiro de M$3. Una vez que los fondos se hayan acreditado correctamente en su cuenta, podrá seleccionar un monto mayor para retirar.',
  'newCharge.tips1': 'Deposita cualquier cantidad para obtener la función de retiro.',
  'newCharge.tips2': 'Deposita M$60 y recibe un bono adicional de M$120.',
  'newCharge.tips3': 'Los usuarios de Recharge pueden recibir dinero gratis todos los días durante 7 días.',
  'newCharge.btn': 'Depósito M$60',
  'withDraw.tips1': 'Estimado usuario, este es su primer retiro. Por favor, seleccione la opción de retiro exclusivo para nuevos usuarios de M$3.',
  'withDraw.tips2': 'Estimado usuario, dado que esta es la primera vez que actualiza a una cuenta premium, para garantizar la seguridad de sus fondos, seleccione primero un retiro de M$3. Una vez que los fondos se hayan acreditado correctamente en su cuenta, podrá seleccionar un monto mayor para retirar.',
  'bookMark.tips1': 'Añade el juego a tu pantalla de inicio para obtener las últimas apuestas y bonos gratis.',
  'bookMark.btn': 'Instalar',
  'service.msg': 'Servicio al cliente en línea',
  'vip.open': 'Desbloquear',
  'vip.charge': 'cierre',
  'tips.notGold': 'Si el saldo de tu cuenta es insuficiente, puedes jugar más partidas para ganar más dinero antes de retirarlo.',
  'newUser.tips1': '¡Enhorabuena! Has sido elegido por la suerte y has ganado una oportunidad gratuita de ganar un premio en metálico.',
  'newUser.tips2': '¡La suerte está de tu lado! ¡Recibe M$<span style="-webkit-text-stroke: 1px black;font-size: 22rem;color: #fef76d;font-weight: 800;">{gold}</span>de efectivo gratis! Ahora puedes ir a jugar y ganar más dinero.',
  'newUser.tips3': 'Haz clic para reclamar',
  'getShare.tips': '¡Enhorabuena por haber invitado con éxito a un amigo! ¡Has ganado una generosa recompensa en efectivo! ¡Reclámala ahora!',
  'share.btn': 'Comparte con tus amigos',
  'Services.Q3': '¿Cuándo llegarán los fondos después del retiro?',
  'Services.S3': 'En circunstancias normales, las transferencias bancarias suelen tardar entre 1 y 5 minutos en llegar. Si el sistema bancario está saturado, vuelva a enviar su solicitud.',
  'withdraw.tips4': 'La orden de retiro se ha enviado al banco. Por favor, revise su cuenta bancaria más tarde.',
  'c.process.tips1': 'Estimado jugador, su nivel de actividad en el juego es insuficiente. Por favor, juegue un rato antes de realizar un retiro.',
  'c.process.tips2': 'Se ha solicitado su orden de retiro, por favor espere: El banco está procesando la transferencia.',
  'c.process.tips3': 'Su solicitud de retiro se ha enviado para su revisión. Por favor, espere: En revisión',
  'c.process.tips4': 'Estimado jugador, su cuenta no está en nuestra lista blanca. Deposite M$150 para desbloquearla y podrá retirar fondos de inmediato.',
  'c.process.tips5': 'Estimado usuario, las solicitudes de retiros importantes requieren revisión manual. Una vez aprobada, la transacción se realizará directamente en la banca para realizar la transferencia.',
  'c.process.tips6': 'Se está realizando una revisión manual.',
  'c.process.tips7': 'Estimado usuario, debido al gran volumen de pedidos que requieren revisión manual, actualmente se encuentra en cola y el tiempo de procesamiento será considerable. ¡Pero no se preocupe! Con su depósito de M$300, podrá acceder de inmediato al canal de retiro súper rápido! ¡Retiro sin colas y en cuestión de segundos! Disfrute de una experiencia de retiro ultra rápida y sencilla.',
  'c.process.tips8': 'Estimado usuario, su pedido de retiro ha sido aprobado por revisión manual y será transferido a su cuenta bancaria de inmediato.',
  'c.process.tips9': 'Recibimos el siguiente comentario del banco: Existe riesgo en su cuenta, lo que ha provocado el fallo del envío. Su pedido ha sido devuelto. Por favor, revise y modifique sus datos bancarios y reemplace el retiro.',
  'c.process.tips10': 'Se cobrará una tarifa de M$600 para modificar el cuenta de retiro. Tras el pago, la información correcta de la cuenta bancaria correspondiente se enviará de inmediato para realizar la transferencia.',
  'c.process.tips11': 'Pago en curso',
  'c.process.tips12': 'En revisión',
  'c.process.tips13': 'Información de la tarjeta bancaria modificada correctamente. Por favor, retire los fondos nuevamente.',
  'c.process.tips14': 'Esperando revisión manual.',
  'History.inProgress': 'en curso',
  'History.success': 'ÉXITOS',
  'History.fail': 'FRACASOS',
  'History.cancel': 'Cancelar',
  'History.paymentIng': 'Pago en curso',
  'newUser.tips2_1': '¡La suerte está de tu lado! ¡Recibe M$',
  'newUser.tips2_2': 'de efectivo gratis! Ahora puedes ir a jugar y ganar más dinero.',
  'eventItem2.21': 'Recompensas diarias',
  'tips.text': 'pista',
}
